export enum MediaType {
  Picture = 'picture',
  Music = 'music',
  Document = 'document',
  Video = 'video',
  Zip = 'archive',
  VectorArt = 'shape',
  SWF = 'swf',
  UFont = 'ufont',
  Watermark = 'watermark',
  SiteIcon = 'site_icon',
  SecurePicture = 'secure_picture',
  SecureMusic = 'secure_music',
  SecureDocument = 'secure_document',
  SecureVideo = 'secure_video',
  SecureZip = 'secure_archive',
  SecureRaw = 'secure_raw',
  ThreeD = '3d',

  Folder = 'folder',
  Mixed = 'mixed',
  Board = 'board',
  All = 'all',
}

export const MEDIA_TYPE_TRANSLATIONS = {
  [MediaType.Picture]: 'media-type.images',
  [MediaType.SecurePicture]: 'media-type.images',
  [MediaType.Video]: 'media-type.videos',
  [MediaType.SecureVideo]: 'media-type.videos',
  [MediaType.Music]: 'media-type.audio',
  [MediaType.SecureMusic]: 'media-type.audio',
  [MediaType.Document]: 'media-type.docs',
  [MediaType.SecureDocument]: 'media-type.docs',
  [MediaType.VectorArt]: 'media-type.vector-art',
  [MediaType.SiteIcon]: 'media-type.site-icon',
  [MediaType.Zip]: 'media-type.zip',
  [MediaType.SecureZip]: 'media-type.zip',
  [MediaType.SWF]: 'media-type.swf',
  [MediaType.ThreeD]: 'media-type.3d',
  [MediaType.SecureRaw]: 'media-type.raw',
  [MediaType.All]: 'media-type.all',
};

export const NON_SECURE_TO_SECURE_MEDIA_TYPES_MAP = {
  [MediaType.Picture]: MediaType.SecurePicture,
  [MediaType.Video]: MediaType.SecureVideo,
  [MediaType.Music]: MediaType.SecureMusic,
  [MediaType.Document]: MediaType.SecureDocument,
  [MediaType.Zip]: MediaType.SecureZip,
  [MediaType.All]: MediaType.All,
};
